import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';
import type { TGuaranteesStepNavigationStyle } from './types.ts';

export const guaranteesStepNavigationStyles = {
  container: ((theme: Theme) => ({
    margin: theme.spacing(1.5, 0, 0, 0),
    padding: theme.spacing(1.5, 1, 0, 1),
  })) satisfies TGuaranteesStepNavigationStyle,
  stepper: ((theme: Theme) => ({
    [theme.breakpoints.up('sm')]: {
      alignItems: 'flex-start',
    },
  })) satisfies TGuaranteesStepNavigationStyle,
  compactContainer: ((theme: Theme) => ({
    maxWidth: 620,
    margin: theme.spacing(1.5, 'auto', 0),
    paddingInline: 0,
    width: '100%',
  })) satisfies TGuaranteesStepNavigationStyle,
  compactStepper: (() => ({
    maxWidth: 620,
    mx: 'auto',
    width: '100%',
  })) satisfies TGuaranteesStepNavigationStyle,
  step: ((theme: Theme) => ({
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingLeft: 0,
      paddingRight: 0,
    },
  })) satisfies TGuaranteesStepNavigationStyle,
  stepLabel: ((theme: Theme) => ({
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      textAlign: 'left',
      '& .MuiStepLabel-labelContainer': {
        marginLeft: theme.spacing(2),
      },
    },
  })) satisfies TGuaranteesStepNavigationStyle,
  clickableStepLabel: ((theme: Theme) => ({
    cursor: 'pointer',
    borderRadius: theme.spacing(0.75),
    outline: 'none',
    '&:focus-visible': {
      boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
    },
    '&:hover .MuiStepIcon-root': {
      transform: 'scale(1.08)',
    },
  })) satisfies TGuaranteesStepNavigationStyle,
  pendingStepIcon: {
    transform: 'scale(1.08)',
  } satisfies SystemStyleObject<Theme>,
  stepIcon: ((theme: Theme) => ({
    width: 30,
    height: 30,
    fontSize: '1.2rem',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shorter,
    }),
    [theme.breakpoints.down('sm')]: {
      width: 25,
      height: 25,
      fontSize: '0.9rem',
    },
  })) satisfies TGuaranteesStepNavigationStyle,
};
